export default __webpack_public_path__ + "static/media/activated.43036f7c.svg";